/* CAFFREY Premium Shoe Cleaning Kit page: hero zoom dialog + one-time reveal of the three tool captions.
   Claude Code (launch builder, WORKFLOW-B), 2026-10-06. Progressive enhancement only: without JS the zoom link opens the
   1600 px image and every caption is visible. The add to cart, Shop Pay and sticky bar come from the kit (cf-kit.js). */
(() => {
  if (window.cfCkPage) return;
  window.cfCkPage = true;

  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn());

  const zoom = () => {
    document.querySelectorAll('[data-ck-zoom]').forEach((link) => {
      const dialog = document.getElementById(link.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const stage = dialog.querySelector('[data-ck-zoom-stage]');
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        if (stage && !stage.querySelector('img')) {
          const img = document.createElement('img');
          img.alt = stage.dataset.alt || '';
          img.width = 1600;
          img.height = 1600;
          img.decoding = 'async';
          img.src = link.href;
          stage.append(img);
        }
        dialog.showModal();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog || event.target.closest('[data-ck-zoom-close]')) dialog.close();
      });
      dialog.addEventListener('close', () => link.focus({ preventScroll: true }));
    });
  };

  const reveal = () => {
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-ck-reveal]').forEach((el) => {
      const box = el.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) return; // already on screen: leave it as it is
      el.classList.add('is-armed');
      const io = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          el.classList.add('is-in');
          io.disconnect();
        }
      }, { threshold: 0.35 });
      io.observe(el);
    });
  };

  ready(() => {
    zoom();
    reveal();
  });
})();
